
__webpack_require__.remotesLoadingData = { chunkMapping: {"255":["8473"]}, moduleIdToRemoteDataMapping: {"8473":{"shareScope":"default","name":"./LandingPage","externalModuleId":2596,"remoteName":"@qpqjs/design-service-views"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
